import { useState } from 'react';
import { Col, Row } from 'reactstrap';

import Table, { useTable } from 'common/components/table';
import useDrawer from 'common/components/drawer/useDrawer';
import TableActions from 'components/layouts/table';
import EnumsDropdown from '../Dropdown';
import company from 'assets/svg/actions/company.svg';
import Form from './form';

const FuelGrades = () => {
  const [active, setActive] = useState(null);
  const [editType, setEdit] = useState(null);

  const drawer = useDrawer();
  const table = useTable({
    label: 'fuel_grades',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        canFilter: false
      },
      {
        header: 'Label',
        key: 'label',
        type: 'string',
        canFilter: false
      },
      {
        header: 'Category',
        key: 'category',
        type: 'string',
        className: 'text-uppercase',
        canFilter: false
      },
      {
        header: 'Max Sulfur',
        key: 'max_sulfur',
        type: 'number',
        canFilter: false
      },
      {
        header: 'With prices',
        key: 'with_prices',
        type: 'boolean',
        options: [
          { label: 'YES', value: true },
          { label: 'NO', value: false }
        ],
        canFilter: false
      },
      {
        header: 'Category default',
        key: 'category_default',
        type: 'boolean',
        options: [
          { label: 'YES', value: true },
          { label: 'NO', value: false }
        ],
        canFilter: false
      },
      {
        header: 'Calorific Value',
        key: 'calorific_value',
        type: 'number',
        canFilter: false
      },
      {
        header: 'Sort Index',
        key: 'sort_index',
        type: 'number',
        canFilter: false
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center'
      }
    ]
  });

  return (
    <Row className="fuel-grades-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions documentTitle="Fuel Grades" title="Enums" dropdown={<EnumsDropdown />} />
      </Col>
      <Col xs={12}>
        <Table
          loader
          drawer={<Form drawer={drawer} active={active} editType={editType} />}
          rows={{
            with_prices: data => <div>{data.with_prices ? 'YES' : 'NO'}</div>,
            category_default: data => <div>{data.category_default ? 'YES' : 'NO'}</div>,
            actions: {
              options: [
                {
                  label: 'Edit Visibility',
                  icon: company,
                  onClick: (_, row) => {
                    setEdit('visibility');
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            }
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default FuelGrades;
